import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import headingSettingInfo from '@/app/editor/sidebar/elementsInfo/heading';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:typography',
    name: 'titleTag',
    targetSelector: '.text-edit',
    default_value: 'h1',
    links: 'font-size,line-height,letter-spacing,text-color,font,textTransform,alignment,box-shadow-enable,extra_class',
    property: '',
  },
  {
    type: 'css:typography',
    name: 'font-size',
    targetSelector: '.text-edit+heading',
    default_value: '20px',
    property: 'font-size',
  },
  {
    type: 'css:typography',
    name: 'line-height',
    targetSelector: '.text-edit+heading',
    default_value: '1.2em',
    property: 'line-height',
    unit: 'em',
  },
  {
    type: 'css:typography',
    name: 'letter-spacing',
    default_value: '1',
    targetSelector: '.text-edit+heading',
    property: 'letter-spacing',
  },
  {
    type: 'css:typography',
    name: 'text-color',
    fieldType: 'color',
    targetSelector: '.text-edit+heading',
    property: 'color',
  },
  {
    type: 'css:typography',
    name: 'font',
    targetSelector: '.text-edit+heading',
    property: 'font-family',
  },
  {
    type: 'css:typography',
    name: 'textTransform',
    targetSelector: '.text-edit+heading',
    property: 'text-transform',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.text-edit',
    property: '',
  },
  {
    type: 'css:typography',
    name: 'box-shadow-color',
    fieldType: 'color',
    targetSelector: '.text-edit+heading',
    default_value: '#333333',
    property: 'text-shadow',
    links: 'gf-to-shadowXY,box-shadow-blur,box-shadow-color',
  },
  {
    type: 'css:typography',
    name: 'gf-to-shadowXY',
    fieldType: 'ShadowAngle',
    targetSelector: '.text-edit+heading',
    default_value: '3.5355339059327378,3.5355339059327373',
    property: 'text-shadow',
    links: 'gf-to-shadowXY,box-shadow-blur,box-shadow-color',
  },
  {
    type: 'css:typography',
    name: 'box-shadow-blur',
    targetSelector: '.text-edit+heading',
    default_value: '5px',
    property: 'text-shadow',
    links: 'gf-to-shadowXY,box-shadow-blur,box-shadow-color',
  },
  {
    type: 'css:group',
    name: 'box-shadow-enable',
    targetSelector: '.text-edit+heading',
    default_value: 0,
    property: 'text-shadow',
    links: 'gf-to-shadowXY,box-shadow-blur,box-shadow-color|stack',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.text-edit',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Button Atom Element
 */
export class GpHeading extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : headingSettingInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || headingSettingInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || headingSettingInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + headingSettingInfo.class;
  }
}
